import { NgModule } from '@angular/core';
import { UsersService } from './services';

@NgModule({
  providers: [UsersService]
})
export class DomainUsersModule {}